export const UPDATE_SUPPLIER_CONTRACT = 'UPDATE_SUPPLIER_CONTRACT';
export const UPDATE_SUPPLIER_CONTRACT_SUCCESS = 'UPDATE_SUPPLIER_CONTRACT_SUCCESS';
export const UPDATE_SUPPLIER_CONTRACT_FAILED = 'UPDATE_SUPPLIER_CONTRACT_FAILED';
export const REQUEST_SUPPLIER_SIGNATURE = 'REQUEST_SUPPLIER_SIGNATURE';
export const REQUEST_SUPPLIER_SIGNATURE_SUCCESS = 'REQUEST_SUPPLIER_SIGNATURE_SUCCESS';
export const REQUEST_SUPPLIER_SIGNATURE_FAILED = 'REQUEST_SUPPLIER_SIGNATURE_FAILED';
export const RESET_SUPPLIER_CONTRACT = 'RESET_SUPPLIER_CONTRACT';

